import React from "react";

export default class _modalInput extends React.Component {
  state = {
    input: "",
  };

  render() {
    const { Bs, VARIANT, SIZE } = this.props;
    return (
      <>
        <Bs
          modal
          show={this.props.modalConfirm.show}
          onHide={() =>
            this.props.returnConfirmModal(
              false,
              this.props.modalConfirm.type,
              this.props.modalConfirm.docno,
              null
            )
          }
          keyboard={false}
          backdrop="static"
          centered
          size={SIZE.MD}
          aria-labelledby="contained-modal-title-vcenter"
        >
          <Bs modalheader closeButton>
            Nyní je vyžadováno potvrzení
          </Bs>
          <Bs modalbody>
            <Bs row>
              <Bs col>
                <Bs small>
                  <Bs bsmarkup markup={this.props.modalConfirm.text} />
                </Bs>
              </Bs>
            </Bs>
            <Bs row className="mt-2">
              <Bs col>
                <Bs
                  formcontrol
                  type="number"
                  min={1000000000}
                  max={9999999999}
                  value={this.state.input}
                  onChange={(e) => this.setState({ input: e.target.value })}
                />
              </Bs>
            </Bs>
            <Bs row className="mt-4">
              <Bs col className="d-flex justify-content-end">
                <Bs
                  button
                  variant={VARIANT.TRANSPARENT}
                  size={SIZE.SM}
                  className="me-4"
                  onClick={() => {
                    this.props.returnConfirmModal(
                      false,
                      this.props.modalConfirm.type,
                      this.props.modalConfirm.docno,
                      null
                    );
                  }}
                >
                  Zrušit
                </Bs>
                <Bs
                  button
                  variant={VARIANT.SUCCESS}
                  size={SIZE.SM}
                  onClick={() => {
                    this.props.returnConfirmModal(
                      true,
                      this.props.modalConfirm.type,
                      this.props.modalConfirm.docno,
                      this.state.input
                    );
                  }}
                >
                  Potvrdit
                </Bs>
              </Bs>
            </Bs>
          </Bs>
        </Bs>
      </>
    );
  }
}
